import { render, staticRenderFns } from "./OrdersArchive.vue?vue&type=template&id=25c5b1d6&scoped=true&"
import script from "./OrdersArchive.vue?vue&type=script&lang=js&"
export * from "./OrdersArchive.vue?vue&type=script&lang=js&"
import style0 from "./OrdersArchive.vue?vue&type=style&index=0&id=25c5b1d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c5b1d6",
  null
  
)

export default component.exports